const phoneLink = '<a href="tel:18773675371" class="phone-link btn btn-primary"><span class="fa fa-phone"></span>&nbsp;1-877-367-5371</a>';
const headerMenuPhoneLink = '<a href="tel:18773675371" class="phone-link btn btn-primary">1-877-367-5371</a>';
const mortgagePhoneLink = '<a href="tel:18332924390" class="phone-link btn btn-primary"><span class="fa fa-phone"></span>&nbsp;1-833-292-4390</a>';
const visitBranchLink = '<a href="https://www.renasantbank.com/locations" class="action" target="_blank">Visit a Branch</a>';
const privacyPolicyLink = '<a class="link" target="_blank" href="https://www.renasantbank.com/resources/privacy-policy">Privacy Policy</a>';
const applyUrl = 'https://validation.renasant.com/';
const cdPromoMinimumToOpen = 'Minimum to open CD is $10,000';
const cdPromoOneTimeExchange = 'One time option during the original term to exchange the interest rate';
const cdPromoAutomaticRenew = 'Will automatically renew at maturity of CD';
const cdPromoCollateral = 'Can be used as collateral for a personal loan';
const cdPromoPenalty = 'A penalty may be imposed for withdrawal before maturity';

export default {
  'guide.name': 'Renasant Bank | Personal Guide',
  'back': 'Back',
  'continue': 'Continue',
  'chooseAllThatApply': 'Select all that apply.',
  phoneLink,
  mortgagePhoneLink,
  visitBranchLink,
  'logo': '/classpath/assets/images/logo.svg',
  'logo-white': '/classpath/assets/images/logo-white.svg',
  'privacy': privacyPolicyLink,
  'nmls': 'NMLS# 402669',
  'nav.prev': 'Back',
  'nav.next': 'Continue',
  'fdicLogo': '/classpath/assets/images/fdic-logo.svg',
  'landing.title': 'Understanding You',
  'landing.message': 'Find the right accounts to meet your needs.',
  'landing.getStartedBtn': 'Get Started ',
  'productTypePreference': 'Tell us why you are here:',
  'productTypePreference.savings': 'Everyday Banking',
  'productTypePreference.lending': 'Loans',
  'postalCode': 'Zip code',
  'summary.welcome': ' ',
  'summary.welcome.subtext': ' ',
  'age': 'Age',
  'annualIncome': 'What is your annual income?',
  'annualIncome.1': 'Prefer not to answer',
  'annualIncome.12500': '$24,999 or less',
  'annualIncome.32500': '$25,000 and $34,999',
  'annualIncome.40000': '$35,000 and $49,999',
  'annualIncome.57500': '$50,000 and $59,999',
  'annualIncome.67500': '$60,000 and $74,999',
  'annualIncome.87500': '$75,000 and $99,999',
  'annualIncome.112500': '$100,000 and $124,000',
  'annualIncome.137500': '$125,000 and $149,999',
  'annualIncome.175000': '$150,000 and $199,999',
  'annualIncome.200000': '$200,000 and up',
  'contactForm.modal.title': 'Contact me',
  'contactMeForm.formInput.firstName': 'First Name*',
  'contactMeForm.formInput.firstName.placeholder': 'Your first name',
  'contactMeForm.formInput.firstName.error.pattern': 'Invalid characters',
  'contactMeForm.formInput.lastName': 'Last Name*',
  'contactMeForm.formInput.lastName.placeholder': 'Your last name',
  'contactMeForm.formInput.lastName.error.pattern': 'Invalid characters',
  'contactMeForm.formInput.email': 'Email*',
  'contactMeForm.formInput.email.placeholder': 'Your email',
  'contactMeForm.formInput.phone': 'Phone number',
  'formInput.error.pattern': 'Enter a valid email',
  'formInput.error.validate': 'Enter a valid number',
  'summary.title': 'Best For Your Needs',
  'summary.subtext': ' ',
  'summary.completeBtn': 'Contact Me',
  'summary.previousPageBtn': 'Back to Guide',
  'summary.print': 'Print',
  'summary.visitABranch': 'Visit a Branch',
  'product.contactUsBtn': 'Contact Me',
  'product.features.title': 'Why best for my needs?',
  'product.applyBtn': 'Open Online',
  'product.learnMore': 'Learn More',
  'product.disclosures.title': 'Additional Information',
  'product.productSelectionHeader': "Let us know about you!\nWe'll contact you as soon as possible.",
  'product.productSelectionLabel': 'Select your preferred products*',
  'loanTerm.15': '15 year',
  'loanTerm.30': '30 year',
  'loanTerm.1': 'I do not have a preference',
  'companions': 'companions',
  'customerType': 'Do you currently bank with Renasant?',
  'customerType.personal': 'Yes, I have personal accounts',
  'customerType.business': 'Yes, I have business accounts',
  'customerType.both': 'Yes, I have both personal and business accounts',
  'customerType.neither': 'No, not yet',
  'whyCustomer': 'Why did you choose Renasant?',
  'whyCustomer.subtext': 'chooseAllThatApply',
  'whyCustomer.reputation': 'Reputation',
  'whyCustomer.referred': 'Referred by family / friend',
  'whyCustomer.branches': 'Convenience of branches',
  'whyCustomer.other': 'Other',
  'averageMonthlyCheckingBalance': 'On average, my checking account balance is:',
  'averageMonthlyCheckingBalance.499': 'Less than $500',
  'details.averageMonthlyCheckingBalance.499': 'Less than $500',
  'averageMonthlyCheckingBalance.500': 'Between $500 and $1,499',
  'details.averageMonthlyCheckingBalance.500': 'Between $500 and $1,499',
  'averageMonthlyCheckingBalance.1501': 'Greater than $1,500',
  'details.averageMonthlyCheckingBalance.1501': 'Greater than $1,500',
  'averageMonthlySavingsBalance.249': 'Less than $250',
  'details.averageMonthlySavingsBalance.249': 'Less than $250',
  'averageMonthlySavingsBalance.250': 'Between $250 and $2,499',
  'details.averageMonthlySavingsBalance.250': 'Between $250 and $2,499',
  'averageMonthlySavingsBalance.2501': 'Greater than $2,500',
  'details.averageMonthlySavingsBalance.2501': 'Greater than $2,500',
  "averageMonthlySavingsBalance": 'On average, my savings account balance is:',
  "haveRewardsChecking": 'Do you have a Rewards Extra Checking account with Renasant?',
  "haveRewardsChecking.true": 'Yes',
  "haveRewardsChecking.false": 'No',
  "wantCheckingRewards": 'Renasant offers Rewards Extra Checking for our clients who want amazing rewards and benefits. Which of the following rewards would benefit you?',
  "wantCheckingRewards.shoppingDiscounts": 'Local and national shopping discounts',
  "wantCheckingRewards.cellPhoneProtection": 'Cell phone protection',
  "wantCheckingRewards.idTheftAssist": 'ID theft assistance',
  "wantCheckingRewards.roadsideAssist": 'Roadside assistance',
  "wantCheckingRewards.medicalDiscounts": 'Savings on prescriptions, eye exams, glasses, and hearing services',
  "wantCheckingRewards.none": 'None of the above',
  "wantToSaveForHealthcare": 'I participate in a high deductible health plan and would love to save for my healthcare.',
  "wantToSaveForHealthcare.true": 'Yes',
  "wantToSaveForHealthcare.false": 'No',
  "wantToSaveForChildren": 'I have at least one child under the age of 18 and would like to open a savings account for my child(ren).',
  "wantToSaveForChildren.true": 'Yes',
  "wantToSaveForChildren.false": 'No',
  "statementType": 'I prefer to receive E-Statements over paper statements:',
  "statementType.electronic": 'Yes',
  "statementType.paper": 'No',
  "wantInterestBearingChecking": 'Earning interest on my checking account is important to me:',
  "wantInterestBearingChecking.true": 'Yes',
  "wantInterestBearingChecking.false": 'No',
  "wantDirectDeposit": 'I currently or plan to use direct deposit:',
  "wantDirectDeposit.true": 'Yes',
  "wantDirectDeposit.false": 'No',
  "numberOfDebitCardTransactions": 'The average number of times per month I use my debit card is:',
  "wantAutomaticPayments": 'I like to set up monthly auto-payments to help pay my bills more efficiently and effectively.',
  "wantAutomaticPayments.true": 'Yes',
  "wantAutomaticPayments.false": 'No',
  "interestedProductsSavings": 'Are you interested in any of the below services?',
  "interestedProductsSavings.zelle": 'Zelle',
  "interestedProductsSavings.billPay": 'BillPay',
  "interestedProductsSavings.mobileDeposit": 'Mobile Deposit',
  "interestedProductsSavings.renasantCardApp": 'Renasant Card App',
  "interestedProductsSavings.mobileBanking": 'Mobile Banking',
  "interestedProductsSavings.onlineBanking": 'Online Banking',
  "interestedProductsSavings.eStatements": 'E-statements',
  "interestedProductsSavings.none": 'Not Interested',
  "loanType": 'I need a loan to:',
  "loanType.purchaseHome": 'Purchase a home',
  "loanType.refinanceHome": 'Refinance a home',
  "loanType.cashOut": 'Cash out refinance',
  "loanAmount": 'Loan Amount:',
  "loanRate": 'What type of loan rate do you prefer?',
  "loanRate.fixed": 'Fixed',
  "loanRate.adjustable": 'Adjustable',
  "loanTerm": 'Which type of term do you prefer?',
  "loanTerm.15.0": '15 year',
  "loanTerm.30.0": '30 year',
  "loanTerm.1.0": 'I do not have a preference',
  "homeEquity": 'Would you like to borrow from the equity in your home?',
  "homeEquity.true": 'Yes',
  "homeEquity.false": 'No',
  "followUpChecking": 'Renasant is a full service bank and can assist you with many financial needs. Can we explore how Renasant may help you with your everyday banking and savings?',
  "followUpChecking.true": 'Yes',
  "followUpChecking.false": 'No',
  "followUpLending": 'Renasant is a full service bank and can assist you with your mortgage lending needs. Would you like to explore how Renasant can help you with your mortgage?',
  "followUpLending.true": 'Yes',
  "followUpLending.false": 'No',
  "interestedProductsLending": 'Are you interested in any of the below services?',
  "interestedProductsLending.zelle": 'Zelle',
  "interestedProductsLending.billPay": 'BillPay',
  "interestedProductsLending.mobileDeposit": 'Mobile Deposit',
  "interestedProductsLending.renasantCardApp": 'Renasant Card App',
  "interestedProductsLending.mobileBanking": 'Mobile Banking',
  "interestedProductsLending.onlineBanking": 'Online Banking',
  "interestedProductsLending.eStatements": 'E-statements',
  "interestedProductsLending.none": 'Not Interested',
  'products': 'Products',
  'products.relatedCompanions': 'Related companions',
  'products.freeWhenAcquiring': 'Included with these products',
  "recommendationDisclosure": "<li>This tool is provided by Renasant Bank for educational and general marketing purposes only and should not be construed as a recommendation or suggestion as to the advisability of any product, service, or course of action.</li><li>If you are seeking investment advice, please be advised that any information provided on this page should not be construed as a recommendation or suggestion as to the advisability of acquiring, holding or disposing of a particular investment, nor should it be construed as a suggestion or indication that the particular investment or investment course of action described herein is appropriate for any specific retirement investor.</li><li>The products recommended are based on your inputs. All products and services are subject to applicable customer agreements, terms, conditions, disclosures, and application requirements.</li>",
  'socialActions.contactMe': 'Contact me',
  'socialActions.print': 'Print',
  'socialActions.email': 'Send a copy',
  'socialActions.sms': 'Text my results',
  'socialActions.visitABranch': 'Visit a branch',
  'socialActions.visitABranch.link': 'https://www.renasantbank.com/locations',
  'shareViaEmail.modal.title': 'Send a copy',
  'shareViaEmail.formBody': 'Write your email and we will send you a link with these results.',
  'shareViaEmail.formInput.emailAddress': 'Email*',
  'shareViaEmail.formInput.emailAddress.placeholder': 'Your email',
  'shareViaSms.submit': 'Send text',
  'shareViaSms.modal.title': 'Text my results',
  'shareViaSms.formBody': 'Write your number and we will send you a message with a link with your results. Standard text messaging rates may apply.',
  'shareViaSms.formInput.phoneNumber': 'Phone number*',
  'shareViaSms.formInput.phoneNumber.placeholder': '(555)-123-4567',
  'shareViaSms.submit': 'Send text',
  'form.submit': 'Send',
  'headerMenu.phoneLink': headerMenuPhoneLink,

  'promo.button.title': 'Special Offer',
  'promo.button.action': 'Click Here',
  'promo.header.title': 'Open a Renasant Certificate of Deposit (CD) and start saving now.',
  'promo.learnMore.link': 'https://www.renasantbank.com/cdspecial',
  'promo.openOnline.link':  'https://validation.renasant.com/',
  'promo.offerDetails.count': 4,
  'promo.body.disclosure': '*The APY (Annual Percentage Yield) is a percentage rate that reflects the total amount of interest paid on the account, based on the interest rate and the frequency of compounding for a one-year period. The disclosed APY is effective as of 6/1/24. The APY assumes interest will remain on deposit until maturity. Penalties of early withdrawal may apply. Fees may reduce earnings. The above rates and terms are offered at this time and are subject to change.',

  'promo.offerDetails.1.count': 7,
  'promo.offerDetails.1.header': '5 Month CD Special',
  'promo.offerDetails.1.1': '5 month term',
  'promo.offerDetails.1.2': '4.00% APY*',
  'promo.offerDetails.1.3': cdPromoMinimumToOpen,
  'promo.offerDetails.1.4': cdPromoOneTimeExchange,
  'promo.offerDetails.1.5': cdPromoAutomaticRenew,
  'promo.offerDetails.1.6': cdPromoCollateral,
  'promo.offerDetails.1.7': cdPromoPenalty,

  'promo.offerDetails.2.count': 7,
  'promo.offerDetails.2.header': '7 Month CD Special',
  'promo.offerDetails.2.1': '7 month term',
  'promo.offerDetails.2.2': '3.90% APY*',
  'promo.offerDetails.2.3': cdPromoMinimumToOpen,
  'promo.offerDetails.2.4': cdPromoOneTimeExchange,
  'promo.offerDetails.2.5': cdPromoAutomaticRenew,
  'promo.offerDetails.2.6': cdPromoCollateral,
  'promo.offerDetails.2.7': cdPromoPenalty,

  'promo.offerDetails.3.count': 7,
  'promo.offerDetails.3.header': '11 Month CD Special',
  'promo.offerDetails.3.1': '11 month term',
  'promo.offerDetails.3.2': '3.75% APY*',
  'promo.offerDetails.3.3': cdPromoMinimumToOpen,
  'promo.offerDetails.3.4': cdPromoOneTimeExchange,
  'promo.offerDetails.3.5': cdPromoAutomaticRenew,
  'promo.offerDetails.3.6': cdPromoCollateral,
  'promo.offerDetails.3.7': cdPromoPenalty,

  // 'promo.offerDetails.4.count': 6,
  // 'promo.offerDetails.4.header': '15 Month CD Special',
  // 'promo.offerDetails.4.1': '15 month term',
  // 'promo.offerDetails.4.2': '3.50% APY*',
  // 'promo.offerDetails.4.3': cdPromoMinimumToOpen,
  // 'promo.offerDetails.4.4': cdPromoAutomaticRenew,
  // 'promo.offerDetails.4.5': cdPromoCollateral,
  // 'promo.offerDetails.4.6': cdPromoPenalty,

  'promo.offerDetails.4.count': 7,
  'promo.offerDetails.4.header': '17 Month CD Special',
  'promo.offerDetails.4.1': '17 month term',
  'promo.offerDetails.4.2': '3.25% APY*',
  'promo.offerDetails.4.3': cdPromoMinimumToOpen,
  'promo.offerDetails.4.4': cdPromoOneTimeExchange,
  'promo.offerDetails.4.5': cdPromoAutomaticRenew,
  'promo.offerDetails.4.6': cdPromoCollateral,
  'promo.offerDetails.4.7': cdPromoPenalty,

  "1050273.name": 'Student Checking',
  "1050273.description": 'With Apple Pay® , Mobile Check Deposit, up to $20 per month in ATM fee refunds<sup>3</sup>, online banking , a debit card and much more, Renasant Student Checking is packed with all the extras you need for your busy life as a student.',
  "1050273.description.abbreviated": 'At Renasant Bank, our goal is to understand and meet your needs.',
  "1050273.url": 'https://www.renasantbank.com/checking/student-checking',
  "1050273.applyUrl": applyUrl,
  "1050273.phoneLink": phoneLink,
  "1050273.features.count": 4,
  "1050273.features.1": 'Earn Interest and ATM fee Refunds<sup>3</sup>',
  "1050273.features.2": 'Online Banking with Online Bill Pay',
  "1050273.features.3": 'Unlimited Check Writing',
  "1050273.features.4": 'Mobile Banking with Mobile Check Deposit',
  "1050273.callToAction.count": 3,
  "1050273.callToAction.1": '<a class="action" href="https://validation.renasant.com/" target="_blank">Open Online</a>',
  "1050273.callToAction.2": phoneLink,
  "1050273.callToAction.3": visitBranchLink,
  "1050273.disclosures.count": 5,
  "1050273.disclosures.1": 'Minimum opening deposit of $50 is required. Offer good on personal accounts only; business and corporate accounts do not qualify for these plans.',
  "1050273.disclosures.2": 'Renasant Student Checking is available for students ages 15 to 25. On your 26th birthday, your account will no longer be eligible for certain benefits: (i) you will no longer be eligible for Tier 2 Rates; and (ii) you will no longer be eligible for ATM refunds. Students must be at least 18 (in most states) to have a single-party account and to apply online. All students under the age of 18 (or the age required in your state) must have a parent or guardian as a multiple-party account owner.',
  "1050273.disclosures.3":
    'To earn higher interest and ATM fee refunds you must have at least 10 debit card transactions (excluding ATM transactions) post and clear per Qualification Cycle* and receive your statement electronically. ' +
    '*Qualification Cycle: This term means a period beginning three (3) business days prior to the beginning of your statement cycle and will end three (3) business days prior to the end of your statement cycle.',
  "1050273.disclosures.4": 'Apple Pay is a registered trademark of Apple Inc.',
  "1050273.disclosures.5": 'Maintenance fee of $10.00 waived each month if receive eStatements or daily account balance is $500 or more.',

  "1050269.name": 'Rewards Checking',
  "1050269.description": 'Rewards Checking is an innovative account that pays. Plus, you get a Renasant Debit Card, Online Banking with Online Bill Pay and Mobile Banking.',

  "1050269.description.abbreviated": 'An interest-bearing account!',
  "1050269.url": 'https://www.renasantbank.com/checking/rewards-checking',
  "1050269.applyUrl": applyUrl,
  "1050269.phoneLink": phoneLink,
  "1050269.features.count": 5,
  "1050269.features.1": 'Debit Card',
  "1050269.features.2": 'Online Banking with Online Bill Pay',
  "1050269.features.3": 'Unlimited Check Writing',
  "1050269.features.4": 'Mobile Banking with Mobile Check Deposit',
  "1050269.features.5": 'Earn up to $20 in ATM fee refunds per monthly statement period.',
  "1050269.callToAction.count": 3,
  "1050269.callToAction.1": '<a class="action" href="https://validation.renasant.com/" target="_blank">Open Online</a>',
  "1050269.callToAction.2": phoneLink,
  "1050269.callToAction.3": visitBranchLink,
  "1050269.disclosures.count": 4,
  "1050269.disclosures.1": 'Minimum opening deposit is only $50.',
  "1050269.disclosures.2":
    'Earn the higher interest rate and ATM fee refunds when you simply do the following during each Qualification Cycle.*<ul><li>Have at least 10 debit card transactions (excluding ATM transactions) post and clear</li><li>Have at least one direct deposit or ACH automatic payment post and clear</li><li>Receive your monthly statement electronically</li></ul>*Qualification Cycle: This term means a period beginning three (3) business days prior to the beginning of your statement cycle and will end three (3) business days prior to the end of your statement cycle.',
  "1050269.disclosures.3": 'Offer good on personal accounts only; business and corporate accounts do not qualify.',
  "1050269.disclosures.4": 'Maintenance fee of $10.00 waived each month if receive eStatements or daily account balance is $1,000 or more.',

  "1050364.name": 'Rewards Extra Checking',
  "1050364.description": 'Rewards Extra Checking includes money saving and personal protection benefits that provide better value and more convenience.',
  "1050364.description.abbreviated": 'Exciting new benefits from your checking account!',
  "1050364.url": 'https://www.renasantbank.com/checking/rewards-extra',
  "1050364.applyUrl": applyUrl,
  "1050364.phoneLink": phoneLink,
  "1050364.features.count": 13,
  "1050364.features.1": 'Mastercard Debit Card',
  "1050364.features.2": 'Interest-Bearing<sup>4</sup>',
  "1050364.features.3": 'Check images',
  "1050364.features.4": 'Unlimited check transactions',
  "1050364.features.5": 'ATM Fee Refunds<sup>4</sup>',
  "1050364.features.6": 'Discounts at local retailers and restaurants',
  "1050364.features.7": 'Health savings card',
  "1050364.features.8": 'Cell phone protection*',
  "1050364.features.9": 'Roadside assistance',
  "1050364.features.10": 'Identity Theft Protection',
  "1050364.features.11": 'Travel accidental death insurance*',
  "1050364.features.12": 'Buyer\'s Protection and Extended Warranty*',
  "1050364.features.13": 'Identity Monitoring and Credit Monitoring',
  "1050364.callToAction.count": 3,
  "1050364.callToAction.1": '<a class="action" href="https://validation.renasant.com/" target="_blank">Open Online</a>',
  "1050364.callToAction.2": phoneLink,
  "1050364.callToAction.3": visitBranchLink,
  "1050364.disclosures.count": 4,
  "1050364.disclosures.1": 'Benefits are subject to additional terms and conditions. Participating merchants on BaZing are not sponsors of the program, are subject to change without notice, may not be available in all regions and may choose to limit deals.',
  "1050364.disclosures.2": '*Insurance products are: NOT A DEPOSIT. NOT FDIC-INSURED. NOT INSURED BY ANY FEDERAL GOVERNMENT AGENCY. NOT GUARANTEED BY RENASANT BANK.',
  "1050364.disclosures.3": 'Rewards Extra Checking is only $6.50 a month. Minimum opening balance of $50.',
  "1050364.disclosures.4": 'Earn the higher interest rate and up to $20 in ATM fee refunds by meeting the three criteria:<ul><li>Have at least 10 debit card transactions (excluding ATM transactions) post and clear per Qualification Cycle**</li><li>Have at least one direct deposit or ACH automatic payment post and clear per Qualification Cycle**</li><li>Receive your monthly statement electronically</li></ul>**Qualification Cycle: This term means a period beginning three (3) business days prior to the beginning of your statement cycle and will end three (3) business days prior to the end of your statement cycle.',

  "1050267.name": 'Simple Checking',
  "1050267.description": 'Simple Checking is simple and straightforward. No monthly maintenance fee with eStatements or daily account balance of $1,000 or more, or a direct deposit made to the account each month; otherwise, $10.00 per month.',
  "1050267.description.abbreviated": 'An all-purpose account for everyone.',
  "1050267.url": 'https://www.renasantbank.com/checking/simple-checking',
  "1050267.applyUrl": applyUrl,
  "1050267.phoneLink": phoneLink,
  "1050267.features.count": 5,
  "1050267.features.1": 'Low minimum opening deposit of $50',
  "1050267.features.2": 'Renasant Bank Mastercard® Debit Card',
  "1050267.features.3": 'Online Banking with Online Bill Pay',
  "1050267.features.4": 'Unlimited Check Writing',
  "1050267.features.5": 'Mobile Banking with Mobile Check Deposit',
  "1050267.callToAction.count": 3,
  "1050267.callToAction.1": '<a class="action" href="https://validation.renasant.com/" target="_blank">Open Online</a>',
  "1050267.callToAction.2": phoneLink,
  "1050267.callToAction.3": visitBranchLink,
  "1050267.disclosures.count": 2,
  "1050267.disclosures.1": 'Minimum opening deposit is only $50.',
  "1050267.disclosures.2": 'Maintenance fee of $10.00 waived each month if receive eStatements or daily account balance is $1,000 or more or a direct deposit made to the account each month.',

  "1050407.name": 'Interest Checking',
  "1050407.description": 'Interest Checking is an innovative account that pays interest on your dollars. Earn interest on balances of $1,500 or more.',
  "1050407.description.abbreviated": '',
  "1050407.url": 'https://renasantbank.com/checking/interest-checking',
  "1050407.applyUrl": applyUrl,
  "1050407.phoneLink": phoneLink,
  "1050407.features.count": 6,
  "1050407.features.1": 'Low opening balance of $50',
  "1050407.features.2": 'No monthly maintenance fee with a daily account balance of $1,500 or more; otherwise, a $10.00 monthly fee',
  "1050407.features.3": 'Renasant Bank Mastercard® Debit Card',
  "1050407.features.4": 'Mobile Banking',
  "1050407.features.5": 'Online Banking',
  "1050407.features.6": 'Online Bill Pay',
  "1050407.callToAction.count": 3,
  "1050407.callToAction.1": '<a class="action" href="https://validation.renasant.com/" target="_blank">Open Online</a>',
  "1050407.callToAction.2": phoneLink,
  "1050407.callToAction.3": visitBranchLink,
  "1050407.disclosures.count": 2,
  "1050407.disclosures.1": 'Earn interest on balances of $1,500 or more.',
  "1050407.disclosures.2": 'Maintenance fee of $10.00 waived each month if daily account balance is $1,500 or more.',

  "1050274.name": 'Regular Savings',
  "1050274.description": 'Here\'s a savings option that you can use for your rainy-day fund. Not only can you set this account to sweep money into your checking account for those times when you need a cushion, but you can also set it up to transfer money from your checking account on a recurring basis. Saving up for that laptop, favorite pair of shoes or beach vacation won\'t be so hard after all.',
  "1050274.description.abbreviated": 'Save money and have over-the-counter access!',
  "1050274.url": 'https://www.renasantbank.com/savings/regular-savings',
  "1050274.applyUrl": applyUrl,
  "1050274.phoneLink": phoneLink,
  "1050274.features.count": 3,
  "1050274.features.1": 'Minimum to open is $250',
  "1050274.features.2": 'Minimum balance to avoid quarterly fee is $250',
  "1050274.features.3": 'Minimum balance of $250 must be maintained every day of the statement cycle in order to earn interest for that statement cycle',
  "1050274.callToAction.count": 3,
  "1050274.callToAction.1": '<a class="action" href="https://validation.renasant.com/" target="_blank">Open Online</a>',
  "1050274.callToAction.2": phoneLink,
  "1050274.callToAction.3": visitBranchLink,
  "1050274.disclosures.count": 2,
  "1050274.disclosures.1": 'Maintenance fee of $15 charged quarterly if the balance falls below $250 during the quarterly statement cycle.',
  "1050274.disclosures.2": '$.07 charged for each item deposited over 150 during the quarterly statement cycle',

  "1050275.name": 'Rewards Savings',
  "1050275.description": 'Rewards Savings is an interest-bearing deposit account designed to compliment Rewards Extra Checking, offering a higher rate of interest when eligibility requirements are met.',
  "1050275.description.abbreviated": 'An account to compliment Rewards Extra Checking!',
  "1050275.url": 'https://www.renasantbank.com/savings/rewards-savings',
  "1050275.applyUrl": applyUrl,
  "1050275.phoneLink": phoneLink,
  "1050275.features.count": 2,
  "1050275.features.1": 'Minimum to open is $250',
  "1050275.features.2": 'Avoid $10 monthly maintenance fee by using eStatements or having a daily account balance of $2,500 or more',
  "1050275.callToAction.count": 3,
  "1050275.callToAction.1": '<a class="action" href="https://validation.renasant.com/" target="_blank">Open Online</a>',
  "1050275.callToAction.2": phoneLink,
  "1050275.callToAction.3": visitBranchLink,
  "1050275.disclosures.count": 2,
  "1050275.disclosures.1": 'Offer good on personal accounts only; business and corporate accounts do not qualify.',
  "1050275.disclosures.2": 'Earn a higher interest rate by meeting the three criteria on a paired Rewards Extra Checking Account: <ul><li>Have at least 10 debit card transactions (excluding ATM transactions) post and clear per Qualification Cycle*</li><li>Have at least one direct deposit or ACH automatic payment post and clear per Qualification Cycle*</li><li>Receive your monthly statement electronically</li></ul>*Qualification Cycle: This term means a period beginning three (3) business days prior to the beginning of your statement cycle and will end three (3) business days prior to the end of your statement cycle.',

  "1050276.name": 'Children\'s Savings',
  "1050276.description": 'Allow your child 18 years or younger to learn what a savings plan is all about.<sup>1,2</sup>',
  "1050276.description.abbreviated": 'Learn to save at a young age!',
  "1050276.url": 'https://www.renasantbank.com/savings/childrens-savings',
  "1050276.phoneLink": phoneLink,
  "1050276.contactMe": true,
  "1050276.features.count": 3,
  "1050276.features.1": 'No minimum to opening deposit – Start saving with any amount',
  "1050276.features.2": 'No monthly maintenance fee – Keep every penny they save',
  "1050276.features.3": 'Earns interest from day one – Watch their savings grow<sup>4</sup>',
  "1050276.callToAction.count": 2,
  "1050276.callToAction.1": phoneLink,
  "1050276.callToAction.2": visitBranchLink,
  "1050276.disclosures.count": 4,
  "1050276.disclosures.1": 'Accounts opened for individuals younger than 14 must be opened under the Uniform Transfer to Minors Act (UTMA).',
  "1050276.disclosures.2": 'Children under the age of 18, or the required age in your state, must have a parent or guardian as a multiple-party account owner.',
  "1050276.disclosures.3": 'The Children\'s Online Privacy Protection Act (COPPA) was passed to give parents increased control over what information is collected from their children online and how such information is used. The law applies to websites and services directed to, and which knowingly collect information from, children under the age of 13. Renasant Bank\'s websites and online services are not directed to children under the age of 13, nor is information knowingly collected from them. For additional information on COPPA protections, link to the Federal Trade Commission\'s website at <a class="disclosuresLink" target="_blank" href="https://www.consumer.ftc.gov/articles/0031-protecting-your-childs-privacy-online">https://www.consumer.ftc.gov/articles/0031-protecting-your-childs-privacy-online</a>.',
  "1050276.disclosures.4": '$.07 charged for each item deposited over 150 during the quarterly statement cycle',

  "1050277.name": 'Health Savings Account',
  "1050277.description": 'HSAs allow individuals with qualified high-deductible health care plans to save on taxes by setting aside interest-earning funds that can be used at the account owner\'s discretion for qualified health care expenses. In addition, the balance within the HSA rolls over year after year, so unlike Flexible Spending Accounts, it does not have to be used fully in a single year—think of it as an IRA for health care expenses!',
  "1050277.description.abbreviated": 'Like an IRA for health expenses!',
  "1050277.url": 'https://www.renasantbank.com/savings/health-savings-account',
  "1050277.phoneLink": phoneLink,
  "1050277.contactMe": true,
  "1050277.features.count": 4,
  "1050277.features.1": 'Deposits for qualified medical expenses are tax-deductible',
  "1050277.features.2": 'Withdrawals for qualified medical expenses are tax-free',
  "1050277.features.3": 'Interest earned each month is tax-free',
  "1050277.features.4": 'Unspent balances carry over from year-to-year',
  "1050277.callToAction.count": 2,
  "1050277.callToAction.1": phoneLink,
  "1050277.callToAction.2": visitBranchLink,
  "1050277.disclosures.count": 4,
  "1050277.disclosures.1": '$50 minimum opening deposit.',
  "1050277.disclosures.2": 'Monthly maintenance fee waived with eStatements or daily account balance of $1,000 or more.  Otherwise $7.50 per month.',
  "1050277.disclosures.3": 'For more detailed information on HSA plans and taxes, talk with your tax advisor.',
  "1050277.disclosures.4": 'Maximum contribution limits apply each tax year.',

  "1050278.name": 'Personal Money Market',
  "1050278.description": 'A Renasant Personal Money Market Account gives you the best of both worlds.It offers competitive interest rates, and you always have access to your funds.',
  "1050278.description.abbreviated": 'Increase the earning power of your money today!',
  "1050278.url": 'https://www.renasantbank.com/savings/money-market',
  "1050278.phoneLink": phoneLink,
  "1050278.features.count": 3,
  "1050278.features.1": 'Save money and have access to your funds!',
  "1050278.features.2": 'Minimum to open is $2,500',
  "1050278.features.3": 'Easy-to-balance statement',
  "1050278.callToAction.count": 2,
  "1050278.callToAction.1": phoneLink,
  "1050278.callToAction.2": visitBranchLink,
  "1050278.disclosures.count": 4,
  "1050278.disclosures.1": 'Minimum balance of $2,500 must be maintained every day of the statement cycle in order to earn interest for that statement cycle.',
  "1050278.disclosures.2": 'Maintenance fee of $15 if account balance falls below $2,500 any day of the statement cycle.',
  "1050278.disclosures.3": '$5 charged for each withdrawal or transfer over six.',
  "1050278.disclosures.4": '$.10 charged for each item deposited over 50 during statement cycle.',

  "1050279.name": 'High Yield Money Market',
  "1050279.description": 'A Renasant High-Yield Money Market Account gives you the best of both worlds. It offers competitive interest rates, and you always have access to your funds.',
  "1050279.description.abbreviated": 'Earn higher interest on higher balances!',
  "1050279.url": 'https://www.renasantbank.com/savings/high-yield-money-market',
  "1050279.phoneLink": phoneLink,
  "1050279.features.count": 2,
  "1050279.features.1": 'Minimum to open is $10,000',
  "1050279.features.2": 'Easy-to-balance statement',
  "1050279.callToAction.count": 2,
  "1050279.callToAction.1": phoneLink,
  "1050279.callToAction.2": visitBranchLink,
  "1050279.disclosures.count": 4,
  "1050279.disclosures.1": 'Minimum balance of $10,000 must be maintained every day of the statement cycle in order to earn interest for that statement cycle.',
  "1050279.disclosures.2": 'Maintenance fee of $15 if account balance falls below $10,000 any day of the statement cycle.',
  "1050279.disclosures.3": 'You may make no more than six preauthorized withdrawals, automatic or telephonic transfers, checks, drafts, and debit card or other similar transactions from your account per month or statement cycle. $25 charged for each withdrawal or transfer over six.',
  "1050279.disclosures.4": '$.10 charged for each item deposited over 50 during statement cycle.',

  "1050307.name": 'Purchase/Refinance Mortgage - Fixed Rate',
  "1050307.description": 'A fixed rate mortgage gives you the ability to lock into a rate for the life of the loan.  We have options with fixed periods of various lengths.  We offer conventional loans, as well as various government loan programs like FHA, USDA, and VA. Start an application now or speak to one of our experienced Loan Officers to find out what option best fits your needs.',
  "1050307.description.abbreviated": 'Renasant Mortgage Lending.  Understanding you.',
  "1050307.url": 'https://renasantbk.mortgagewebcenter.com/LoanOfficer/Search',
  "1050307.phoneLink": mortgagePhoneLink,
  "1050307.contactMe": true,
  "1050307.features.count": 1,
  "1050307.features.1": 'A fixed rate mortgage offers a rate that will not change for the life of the loan.',

  "1050308.name": 'Purchase/Refinance Mortgage - Adjustable Rate',
  "1050308.description": 'An adjustable rate mortgage gives you the benefit of an introductory rate during the initial years of the loan.  The rate would then adjust according to an index after the introductory period. We offer conventional loans, as well as government loan programs such as FHA loans.  Start an application now or speak to one of our experienced Loan Officers to find out what option best fits your needs.',
  "1050308.description.abbreviated": 'Renasant Mortgage Lending.  Understanding you.',
  "1050308.url": 'https://renasantbk.mortgagewebcenter.com/LoanOfficer/Search',
  "1050308.phoneLink": mortgagePhoneLink,
  "1050308.contactMe": true,
  "1050308.features.count": 1,
  "1050308.features.1": 'An adjustable rate mortgage may be best for those comfortable with an interest rate and payments which may change after the introductory period.',

  "1050309.name": 'Cash-Out Refinance',
  "1050309.description": 'The equity in your home can be used to reduce high interest debt to a more manageable monthly payment or can be used for renovations that can increase the value of your home.  It can also be used to meet other life\'s needs such as a vacation, an education or a wedding.  We offer conventional loans, as well as various government loan programs like FHA, USDA, and VA. Start an application now or speak to one of our experienced Loan Officers to find out what option best fits your needs.',
  "1050309.description.abbreviated": 'Renasant Mortgage Lending.  Understanding you.',
  "1050309.url": 'https://renasantbk.mortgagewebcenter.com/LoanOfficer/Search',
  "1050309.phoneLink": mortgagePhoneLink,
  "1050309.contactMe": true,
  "1050309.features.count": 1,
  "1050309.features.1": 'Using the equity in your home can be a cost effective way to meet your financial demands.',

  "1050400.name": 'Online Banking',
  "1050400.description": 'With online banking, you can access your accounts anytime from anywhere with internet access. Our online suite of powerful tools and great features offers more than the ability to check account balances and review your transaction history - you can also make transfers, schedule alerts, pay bills and more.',
  "1050400.description.abbreviated": 'Bank on the go, wherever life takes you.',
  "1050400.url": 'https://www.renasantbank.com/digital-banking',
  "1050400.features.count": 1,
  "1050400.features.1": 'Online Banking saves time by managing accounts, paying bills and other related banking activities from your computer or cell phone.',

  "1050401.name": 'Mobile Banking',
  "1050401.description": 'Mobile banking lets you take control of your debit card, check your account balances, make transfers, pay bills, deposit checks from your phone, send and receive person-to-person payments and more - all through the app.',
  "1050401.description.abbreviated": 'Access your account anytime, from anywhere.',
  "1050401.url": 'https://www.renasantbank.com/mobile-banking',
  "1050401.features.count": 1,
  "1050401.features.1": 'With mobile banking, you can bank from anywhere. Skip the lobby or the drive thru with our mobile check deposit feature, or send and receive money through Zelle - all through the app.',

  "1050402.name": 'Zelle®',
  "1050402.description": 'Securely move money through online banking or the mobile banking app you already use and trust with Zelle®. Need to pay the babysitter? Split the cost for the pizza? Pay for lunch? Do it with Zelle®.',
  "1050402.description.abbreviated": 'Send and receive money directly with friends and family with Zelle®.',
  "1050402.url": 'https://www.renasantbank.com/digital-banking/zelle',
  "1050402.features.count": 1,
  "1050402.features.1": 'Send and receive money directly with friends and family with Zelle.',

  "1050403.name": 'BillPay',
  "1050403.description": 'With Bill Pay, you can make online payments without writing checks, addressing envelopes, buying stamps or making trip to the post office.',
  "1050403.description.abbreviated": 'Pay your bills anytime, anywhere!',
  "1050403.url": 'https://www.renasantbank.com/digital-banking/bill-pay',
  "1050403.features.count": 1,
  "1050403.features.1": 'Schedule automatic payments, save and store payee details, reduce risk of fraud and create and review reports with Bill Pay.',

  "1050404.name": 'Mobile Deposit',
  "1050404.description": 'Skip the drive thru with Mobile Check Deposit. Just upload a photo of the front and back of your check, confirm the amount and you\'re all set.',
  "1050404.description.abbreviated": 'Depositing a check is quick and easy.',
  "1050404.url": 'https://www.renasantbank.com/mobile-check-deposit',
  "1050404.features.count": 1,
  "1050404.features.1": 'Life moves quickly, and a trip to the drive thru shouldn\'t slow you down. Keep moving and skip the drive thru with Mobile Check Deposit.',

  "1050405.name": 'Renasant Card App',
  "1050405.description": 'The Renasant Card App has all the best tools to control your debit card from your phone. Set spending limits and alerts, turn debit cards on/off if lost or stolen, receive spending insights and more.',
  "1050405.description.abbreviated": 'Take control of your debit card.',
  "1050405.url": 'https://www.renasantbank.com/renasant-card-app',
  "1050405.features.count": 1,
  "1050405.features.1": 'Renasant Card App lets you track spending in real time, know where your money is going, fight fraud, plan ahead and react in real time to transactions made on your debit card.',

  "1050406.name": 'E-statements',
  "1050406.description": 'View, save and print your account statements through online or mobile banking whenever you wish.',
  "1050406.description.abbreviated": 'View, save and print online.',
  "1050406.url": 'https://www.renasantbank.com/resources/estatements',
  "1050406.features.count": 1,
  "1050406.features.1": 'E-Statements are fast, convenient, secure and environmentally friendly.'
}
